import StripeJS from "stripe";
import { create } from "zustand";
import { Promo } from "../../../Common/models/promos";
import { WLFormInputProps } from "../../../Common/components/WLForms/WLFormInput/WLFormInput";

interface WLPromoState {
  validPromoCode: string | undefined;
  setValidPromoCode: (value: string | undefined) => void;

  validCouponCode: string | undefined;
  setValidCouponCode: (value: string | undefined) => void;

  validWLPromo: Promo | null | undefined;
  setValidWLPromo: (value: Promo | null | undefined) => void;

  defaultPromoCode: undefined | null | string;
  setDefaultPromoCode: (value: undefined | null | string) => void;

  validStripeCoupon: undefined | null | StripeJS.Coupon;
  setValidStripeCoupon: (value: StripeJS.Coupon | null | undefined) => void;

  promoField: undefined | WLFormInputProps;
  setPromoField: (state: WLFormInputProps) => void;

  promoValidating: boolean;
  setPromoValidating: (state: boolean) => void;

  setPromoFieldValue:
    | undefined
    | ((
        name: string,
        value: any,
        options?:
          | Partial<{
              shouldValidate: boolean;
              shouldDirty: boolean;
              shouldTouch: boolean;
            }>
          | undefined
      ) => void);

  setPromoFieldValueFunc: (
    state: (
      name: string,
      value: any,
      options?:
        | Partial<{
            shouldValidate: boolean;
            shouldDirty: boolean;
            shouldTouch: boolean;
          }>
        | undefined
    ) => void
  ) => void;

  triggerFieldValidation:
    | undefined
    | ((
        name?: string | string[] | readonly string[] | undefined,
        options?:
          | Partial<{
              shouldFocus: boolean;
            }>
          | undefined
      ) => Promise<boolean>);

  setTriggerFieldValidationFunc: (
    state: (
      name?: string | string[] | readonly string[] | undefined,
      options?:
        | Partial<{
            shouldFocus: boolean;
          }>
        | undefined
    ) => Promise<boolean>
  ) => void;

  resetPromoField: undefined | (() => void);
  setResetPromoFieldFunc: (func: () => void) => void;

  reset: () => void;
}

const useWLPromoStore = create<WLPromoState>((set) => ({
  validPromoCode: "",
  setValidPromoCode: (validPromoCode) => set({ validPromoCode }),

  defaultPromoCode: undefined,
  setDefaultPromoCode: (defaultPromoCode) => set({ defaultPromoCode }),

  validCouponCode: "",
  setValidCouponCode: (validCouponCode) => set({ validCouponCode }),

  validWLPromo: undefined,
  setValidWLPromo: (validPromoCodePromo) =>
    set({ validWLPromo: validPromoCodePromo }),

  validStripeCoupon: undefined,
  setValidStripeCoupon: (validStripeCoupon) => set({ validStripeCoupon }),

  promoField: undefined,
  setPromoField: (promoField) => set({ promoField }),

  setPromoFieldValue: undefined,
  setPromoFieldValueFunc: (setPromoFieldValue) => set({ setPromoFieldValue }),

  triggerFieldValidation: undefined,
  setTriggerFieldValidationFunc: (triggerFieldValidation) =>
    set({ triggerFieldValidation }),

  resetPromoField: undefined,
  setResetPromoFieldFunc: (resetPromoField) => set({ resetPromoField }),

  promoValidating: false,
  setPromoValidating: (promoValidating) => set({ promoValidating }),

  reset: () =>
    set({
      validPromoCode: "",
      validCouponCode: "",
      promoValidating: false,
      validWLPromo: undefined,
      validStripeCoupon: undefined,
      promoField: undefined,
      setPromoFieldValue: undefined,
      triggerFieldValidation: undefined,
    }),
}));

export default useWLPromoStore;
